// extracted by mini-css-extract-plugin
export var dropdown = "_u1-0";
export var imageWrapper = "_u1-3";
export var itemNameContainer = "_u1-1";
export var productImage = "_u1-2";
export var spinnerWrapper = "_u1-4";